import { LoaderCircle } from 'lucide-react'

export function FullPageLoader() {
  return (
    <div className="grid min-h-dvh place-items-center bg-orange-50" aria-label="Đang tải">
      <LoaderCircle className="h-8 w-8 animate-spin text-orange-500" />
    </div>
  )
}
